import React from "react";
import './i18n';
import { WidgetProvider } from "./widgetContext";
import Widget from "./pages/Widget";




export const WidgetV1 = () => {

    return (
        <WidgetProvider>
            <Widget />
        </WidgetProvider>

    )

}